import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { TranslationMappingService } from '../../core/services/translation-mapping.service';

@Pipe({
  name: 'appTranslate',
  pure: false // Set to false to handle language changes dynamically
})
export class AppTranslatePipe implements PipeTransform {
  constructor(
    private translateService: TranslateService,
    private mappingService: TranslationMappingService
  ) {}

    transform(value: string, interpolateParams?: any): string {
    if (!value) {
      return value;
    }

    // Check if the value is already a translation key (contains dots and all caps)
    const isTranslationKey = /^[A-Z_]+\.[A-Z_]+/.test(value);
    
    if (isTranslationKey) {
      // If it's already a translation key, use it directly.
      return this.translateService.instant(value, interpolateParams);
    }

    // Get the translation key from the mapping service for display text.
    const translationKey = this.mappingService.getTranslationKey(value);
    const translated = this.translateService.instant(translationKey, interpolateParams);

    // instant() echoes the key back when the locale file has no entry for it,
    // which would render raw text like "REPORTS.TAX_REPORT" in the menu. Fall
    // back to the original English title instead.
    return translated === translationKey && translationKey !== value
      ? value
      : translated;
  }
}
